import React from "react";
import jadaimg from "../../../assets/media/img/hero-about-img.svg";
const HeroAbout = () => {
  return (
    <section className="sectionn first-sectionn | md:pt-[155px] md:py-94px md:px-30px | pt-[135px] py-64px px-20px">
      <div className="section-containerr about-hero | flex justify-between items-center m-auto max-w-[1560px] | md:flex-row md:gap-64px | flex-col gap-48px">
        <div className="left">
          <h1 className="max-w-lg font-bold leading-[110%] text-primary-900 | md:leading-[110%] md:text-5xl md:mt-32px | text-[40px] mb-16px mt-20px">
            A Part of The Long Journey
          </h1>
          <p className="max-w-[530px] text-accent-400 leading-[150%] font-light | md:mb-32px md:text-base | mb-20px text-sm ">
            This project is designed and developed with much love by the
            passionate designer who codes JADA Mohamed as part of full stack
            devolvement journey.
          </p>
          <button className="py-10px px-30px rounded-full bg-gradient-to-b from-primary-500 to-secondary-500 font-medium text-white hover:opacity-90 duration-300 cursor-pointer">
            Contact Jada
          </button>
        </div>
        <div className="right | flex">
          <img className="max-w-[380px] w-full" src={jadaimg} alt="" />
        </div>
      </div>
    </section>
  );
};
export default HeroAbout;
